import { brandInfoProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoUtils";
import { debugInfoSectionPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/debugInfoSectionPropsILeanProductTileAdapter";
import { productTileFavoritePropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import { searchProductImagePropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageProps";
import { ClientFormatMoneyPriceWrapperProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { productTileClickProviderPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/ProductTileClickProviderProps";
import { productTileOverlayProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayUtils";
import { productTileTrackingWrapperPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapperProps";
import { productTileQuickAddPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { textBadgesProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/textBadgesUtils";
import { productTileTopBadgesPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";
import { DiscoverProductTileProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/DiscoverProductTileProps";
import { LoggedInSearchProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/LoggedInSearchProductTile";
import { LoggedOutSearchProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/LoggedOutSearchProductTile";
import { ISearchProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/productTileTypes";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { PrehydrationClickTrackingWrapper } from "@faire/retailer-visitor-shared/lib/nextjs-rsc/PrehydrationClickTrackingWrapper";
import { showProductPromotions } from "@faire/retailer-visitor-shared/lib/showProductPromotions";
import { useSettingLoggedOutProductTilePrice } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutProductTilePrice";
import { PRICE_TEXT_SURFACE } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/PriceProps";
import { useSearchPageIsRsc } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageIsRsc";
import { useSearchPageSpellCorrectedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageActionName } from "@faire/retailer-visitor-shared/views/search-v2/util/useSearchPageActionName";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import React from "react";

export const SearchProductTile: React.FC<ISearchProductTile> = (props) => {
  useTraceComponentRender("SearchProductTile", {
    productToken: props.productTile.product?.token,
  });
  const isLoggedIn = useIsLoggedInRetailerOrBrandPreview();
  const { productTile, brand } = props;
  const loggedOutPriceTestVariant = useSettingLoggedOutProductTilePrice();
  const productSearchString = useSearchPageProductSearchString();
  const spellCorrectedQuery = useSearchPageSpellCorrectedQuery();

  if (!productTile.product?.token) {
    // TODO loading state should probably live in the composable elements
    return null;
  }

  const searchPriceTextProps: ClientFormatMoneyPriceWrapperProps = {
    min_option_wholesale_price: productTile.min_option_wholesale_price,
    min_option_wholesale_promo_price:
      productTile.min_option_wholesale_promo_price,
    min_option_retail_price: productTile.min_option_retail_price,
    showProductPromotions: showProductPromotions(
      productTile.min_option_wholesale_promo_price
    ),
    small: true,
    isLoggedInOrBrandPreview: isLoggedIn,
    isTilePricing: true,
    priceTextSurface: PRICE_TEXT_SURFACE.PRODUCT_TILE,
  };

  const searchProductTileProps: DiscoverProductTileProps = {
    productTileImageClientProps: searchProductImagePropsILeanProductTileAdapter(
      productTile,
      productSearchString,
      spellCorrectedQuery
    ),
    productTileTrackingWrapperProps:
      productTileTrackingWrapperPropsILeanProductTileAdapter(productTile),
    productTileDebugInfoProps:
      debugInfoSectionPropsILeanProductTileAdapter(productTile),
    productTileTopBadgesProps:
      productTileTopBadgesPropsILeanProductTileAdapter(productTile),
    productTileFavoriteProps:
      productTileFavoritePropsILeanProductTileAdapter(productTile),
    productTileQuickAddProps:
      productTileQuickAddPropsILeanProductTileAdapter(productTile),
    productTileClickProviderProps:
      productTileClickProviderPropsILeanProductTileAdapter(productTile),
    priceTextProps: searchPriceTextProps,
    brand: isLoggedIn ? undefined : brand,
    brandToken: isLoggedIn ? brand?.token : undefined,
    productSearchString,
    loggedOutPriceTestVariant,
    productOptionDetails: productTile.options_details,
    productName: productTile.product?.name ?? "",
    productTileTextBadgesProps: isLoggedIn
      ? textBadgesProductTileAdaptor(productTile)
      : undefined,
    brandInfoData: isLoggedIn
      ? brandInfoProductTileAdaptor({
          productTile,
          brand,
          productSearchString,
          isLoggedInRetailer: true,
        })
      : getLoggedOutBrandInfoData({
          productTile,
          brand,
          productSearchString,
          loggedOutPriceTestVariant,
        }),
    productTileOverlayProps: isLoggedIn
      ? productTileOverlayProductTileAdaptor(productTile, true)
      : undefined,
  };

  if (isLoggedIn) {
    return <LoggedInSearchProductTile data={searchProductTileProps} />;
  } else {
    return <LoggedOutSearchProductTile data={searchProductTileProps} />;
  }
};

export const SearchProductTilePrehydrationClickTrackingWrapper = ({
  productToken,
  children,
}: {
  productToken: string;
  children: React.ReactNode;
}) => {
  const actionName = useSearchPageActionName();
  const isRsc = useSearchPageIsRsc();
  return (
    <PrehydrationClickTrackingWrapper
      name={actionName}
      isRsc={isRsc}
      location={`product-tile-${productToken}`}
    >
      {children}
    </PrehydrationClickTrackingWrapper>
  );
};

const getLoggedOutBrandInfoData = ({
  productTile,
  brand,
  productSearchString,
  loggedOutPriceTestVariant,
}: {
  productTile: ILeanProductTile;
  brand: ILeanProductTile.IBrand | undefined;
  productSearchString: string;
  loggedOutPriceTestVariant: IThreeVariantXP;
}) => {
  const shouldHidePriceProminencePriceTestV3 =
    loggedOutPriceTestVariant === IThreeVariantXP.Bucket.VARIANT_3;
  const isLoggedOutProductTilePriceTest =
    loggedOutPriceTestVariant !== IThreeVariantXP.Bucket.CONTROL;

  return brandInfoProductTileAdaptor({
    productTile,
    productSearchString,
    brand,
    isLoggedInRetailer: false,
    isLoggedOutProductTilePriceTest,
    shouldHidePriceProminencePriceTestV3,
  });
};
